
// import React, { useState } from "react";
// import Swal from "sweetalert2";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import loginLogo from "../../Assets/Images/login-logo.png";
// import { API_BASE_URL } from "../../utils/index";
// import { Button } from "@mui/material";

// export default function ChangePassword() {
//   const { id } = useParams();
//   const [currentPassword, setCurrentPassword] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");

//   const [hideCurrent, setHideCurrent] = useState(false);
//   const [hideNew, setHideNew] = useState(false);
//   const [hideConfirm, setHideConfirm] = useState(false);

//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!currentPassword || !newPassword || !confirmPassword) {
//       Swal.fire("Warning", "All fields are required", "warning");
//       return;
//     }
//     if (newPassword !== confirmPassword) {
//       Swal.fire(
//         "Error",
//         "New Password and Confirm Password must match",
//         "error"
//       );
//       return;
//     }

//     try {
//       // Example token retrieval - adjust as needed
//       const token = localStorage.getItem("vendorsccesstoken");

//       const response = await axios.patch(
//         `${API_BASE_URL}/vendor/${id}/change-password`,
//         {
//           oldPassword: currentPassword,
//           newPassword: confirmPassword,
//           //   confirmPassword,
//         },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       //   Swal.fire(
//       //     "Success",
//       //     response.data.message || "Password changed successfully",
//       //     "success"
//       //   );
//       // Optionally clear inputs or navigate
//       setCurrentPassword("");
//       setNewPassword("");
//       setConfirmPassword("");
//       navigate(`/${id}/dashboard`);
//     } catch (error) {
//       Swal.fire(
//         "Error",
//         error?.response?.data?.message || "Failed to change password",
//         "error"
//       );
//     }
//   };

//   const renderPasswordInput = (
//     id,
//     label,
//     value,
//     onChange,
//     hide,
//     toggleHide
//   ) => (
//     <div className="my-3" style={{ maxWidth: "400px" }}>
//       <label htmlFor={id} className="form-label">
//         {label}
//       </label>
//       <div className="input-group">
//         <input
//           id={id}
//           type={hide ? "text" : "password"}
//           className="form-control"
//           value={value}
//           onChange={onChange}
//           placeholder={label}
//           autoComplete="current-password"
//           required
//         />
//         <span
//           className="input-group-text"
//           style={{ cursor: "pointer" }}
//           onClick={toggleHide}
//           role="button"
//           tabIndex={0}
//           onKeyDown={(e) => {
//             if (e.key === "Enter" || e.key === " ") toggleHide();
//           }}
//           aria-label={hide ? `Hide ${label}` : `Show ${label}`}
//         >
//           {hide ? <FaEyeSlash /> : <FaEye />}
//         </span>
//       </div>
//     </div>
//   );

//   return (
//     <div className="login-page d-flex align-items-center">
//       <div className="container">
//         <div className="row ">
//           <div className="col-md-6 text-center">
//             <div className="login-logor text-center">
//               <img src={loginLogo} alt="Login Logo" />
//             </div>
//           </div>
//           <div className="col-md-6">
//             <form className="right" onSubmit={handleSubmit}>
//               <p className="login-title">Change Your Password</p>

//               {renderPasswordInput(
//                 "current-password",
//                 "Current Password",
//                 currentPassword,
//                 (e) => setCurrentPassword(e.target.value),
//                 hideCurrent,
//                 () => setHideCurrent(!hideCurrent)
//               )}

//               {renderPasswordInput(
//                 "new-password",
//                 "New Password",
//                 newPassword,
//                 (e) => setNewPassword(e.target.value),
//                 hideNew,
//                 () => setHideNew(!hideNew)
//               )}

//               {renderPasswordInput(
//                 "confirm-password",
//                 "Confirm Password",
//                 confirmPassword,
//                 (e) => setConfirmPassword(e.target.value),
//                 hideConfirm,
//                 () => setHideConfirm(!hideConfirm)
//               )}

//               <div className="mt-3">
//                 <Button type="submit" className="btn submit-button w-75" style={{ background: "#f04b25" }}>
//                   Change Password
//                 </Button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Button,
  Paper,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import loginLogo from "../../Assets/Images/login-logo.png";
import { API_BASE_URL } from "../../utils/index";

export default function ChangePassword() {
  const { id } = useParams();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [hideCurrent, setHideCurrent] = useState(false);
  const [hideNew, setHideNew] = useState(false);
  const [hideConfirm, setHideConfirm] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!currentPassword || !newPassword || !confirmPassword) {
      Swal.fire("Warning", "All fields are required", "warning");
      return;
    }
    if (newPassword !== confirmPassword) {
      Swal.fire("Error", "New Password and Confirm Password must match", "error");
      return;
    }

    try {
      const token = localStorage.getItem("vendorsccesstoken");

      const response = await axios.patch(
        `${API_BASE_URL}/vendor/${id}/change-password`,
        {
          oldPassword: currentPassword,
          newPassword: confirmPassword,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      navigate(`/${id}/dashboard`);
    } catch (error) {
      Swal.fire(
        "Error",
        error?.response?.data?.message || "Failed to change password",
        "error"
      );
    }
  };

  const renderPasswordInput = (
    id,
    label,
    value,
    onChange,
    hide,
    toggleHide
  ) => (
    <TextField
      fullWidth
      type={hide ? "text" : "password"}
      label={label}
      // variant="outlined"
      value={value}
      onChange={onChange}
      id={id}
      size="small"
      margin="normal"
      // sx={{
      //   "& .MuiOutlinedInput-root": {
      //     "& fieldset": {
      //       borderColor: "#fff", // White border
      //     },
      //     "&:hover fieldset": {
      //       borderColor: "#fff",
      //     },
      //     "&.Mui-focused fieldset": {
      //       borderColor: "#fff",
      //     },
      //   },
      // }}
      // InputLabelProps={{
      //   style: { color: "#fff" }, // label color
      // }}
      InputProps={{
        // style: { backgroundColor: "#f5f5f5" },
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={toggleHide}
              onMouseDown={(e) => e.preventDefault()}
              edge="end"
              aria-label={hide ? `Hide ${label}` : `Show ${label}`}
            >
              {hide ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );

  return (
    <Box className="login-page" display="flex" alignItems="center" minHeight="100vh">
      <Container>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6} textAlign="center">
            <img src={loginLogo} alt="Login Logo" style={{ maxWidth: "80%", height: "auto" }} />
          </Grid>
          <Grid item xs={12} md={6} textAlign="center">
            <Paper elevation={0} sx={{ p: 4, maxWidth: 400, mx: "auto", boxShadow: "none", }}>

              <form onSubmit={handleSubmit}>
                <Typography variant="h5" gutterBottom style={{ fontFamily: "Poppins" }}>
                  Change Your Password
                </Typography>

                {renderPasswordInput(
                  "current-password",
                  "Current Password",
                  currentPassword,
                  (e) => setCurrentPassword(e.target.value),
                  hideCurrent,
                  () => setHideCurrent(!hideCurrent)
                )} <br />
                {renderPasswordInput(
                  "new-password",
                  "New Password",
                  newPassword,
                  (e) => setNewPassword(e.target.value),
                  hideNew,
                  () => setHideNew(!hideNew)
                )}<br></br>
                {renderPasswordInput(
                  "confirm-password",
                  "Confirm Password",
                  confirmPassword,
                  (e) => setConfirmPassword(e.target.value),
                  hideConfirm,
                  () => setHideConfirm(!hideConfirm)
                )}

                <Box mt={2} textAlign="center">
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    sx={{ backgroundColor: "#f04b25", color: "#fff" }}
                  >
                    Change Password
                  </Button>
                </Box>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
